module.exports = __webpack_public_path__ + "static/media/plan-a-party.a6917d73.png";